import BaseFoundation, { DefaultAdapter } from '../base/foundation';

export default class ScrollListFoundation extends BaseFoundation<DefaultAdapter> {}
